module.exports = __webpack_public_path__ + "img/CPA過去問.7f25f522.png";